import React, { useState } from 'react';
import { fetchWithAuth } from '../utils/api';
import { apiConfig } from '../config/apiConfig';

export const ApiDebug = () => {
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [endpoint, setEndpoint] = useState('/debug/connection-test/');

  const testApi = async () => {
    setLoading(true);
    setError('');
    try {
      console.log('Current API base URL:', apiConfig.baseURL);
      const data = await fetchWithAuth(endpoint, { method: 'GET' });
      setResult(data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded-md">
      <h2 className="text-xl font-semibold mb-4">API Debug Tool</h2>
      <div className="mb-4">
        <label className="block mb-2">API Endpoint:</label>
        <input
          className="w-full p-2 border rounded"
          value={endpoint}
          onChange={(e) => setEndpoint(e.target.value)}
          placeholder="/api/endpoint"
        />
      </div>
      <button 
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        onClick={testApi}
        disabled={loading}
      >
        {loading ? 'Testing...' : 'Test API Endpoint'}
      </button>
      
      {error && (
        <div className="mt-4 p-4 bg-red-100 border border-red-500 rounded text-red-700">
          <p>{error}</p>
        </div>
      )}
      
      {result && (
        <div className="mt-4 p-4 bg-green-100 border border-green-500 rounded">
          <h3 className="font-medium mb-2">Response:</h3>
          <pre className="bg-gray-100 p-2 overflow-auto text-xs">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default ApiDebug;